import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import { rewardBandit } from 'src/app/shared/api/bandits';

export function useRewardBandits() {
	const utilityContext = useUtilityContext();
	const {
		data: { bandits },
	} = usePsfSharePageData();

	return useCallback(async () => {
		return Promise.all([
			bandits.psfShareCopy.variant &&
				rewardBandit(
					{
						experimentName: bandits.psfShareCopy.experimentName,
						variantName: bandits.psfShareCopy.variant.variantName,
					},
					utilityContext,
					{ silent: true },
				),
		]);
	}, [bandits, utilityContext]);
}
